// extracted by mini-css-extract-plugin
export default {"reportHeader":"pdfReport_reportHeader__bh5Rf","reportTitle":"pdfReport_reportTitle__GTOA7","btnIcon":"pdfReport_btnIcon__TuZot"};